import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Role, useAuth } from "@context/AuthContext";
import { MENU_ITEMS, BOTTOM_MENU_ITEMS } from "@lib/constants/general";
import { X, Menu } from "lucide-react";

const MobileNav: React.FC = () => {
  const { role } = useAuth();
  const [open, setOpen] = useState(false);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  return (
    <>
      <button
        onClick={handleDrawerToggle}
        className="relative z-50 p-2 text-gray-900 justify-center items-center rounded-md lg:hidden"
      >
        <Menu size={24} />
      </button>

      {open && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex justify-start z-50 lg:hidden">
          <div className="bg-gray-800 text-white w-64 h-full shadow-lg flex flex-col relative">
            <button
              onClick={handleDrawerToggle}
              className="flex justify-end p-2 text-white focus:outline-none"
            >
              <X size={24} />
            </button>

            <div className="flex items-center justify-between p-4">
              <img src="/assets/Hublogiq_Logo_Wit_L.png" alt="screenshot" />
            </div>

            <div className="divide-y flex flex-col flex-1 overflow-y-auto">
              <div className="space-y-2 p-2">
                {MENU_ITEMS.filter((item) =>
                  item.roles.includes(role as Role)
                ).map((item) => (
                  <Link
                    key={item.title}
                    to={item.href}
                    className="flex items-center px-4 py-2 space-x-3 transition-all duration-200 hover:bg-gray-700 hover:rounded-md"
                    onClick={handleDrawerToggle}
                  >
                    <item.icon className="flex-shrink-0" />
                    <span className="opacity-100 scale-100">{item.title}</span>
                  </Link>
                ))}
              </div>

              <div className="absolute bottom-4 w-full">
                {BOTTOM_MENU_ITEMS.filter((item) =>
                  item.roles.includes(role as Role)
                ).map((item) => (
                  <Link
                    key={item.title}
                    to={item.href}
                    className="flex items-center px-4 py-2 space-x-3 transition-all duration-200 hover:bg-gray-700"
                    onClick={handleDrawerToggle}
                  >
                    <item.icon className="flex-shrink-0" />
                    <span className="opacity-100 scale-100">{item.title}</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileNav;
